module.exports = __webpack_public_path__ + "static/media/wallet.644975d6.svg";